<template>
	<script type="text/x-template" id="template-primaries" class="template">
		<li class="block edit_block primaries-block adjustment-block">
		    <div class="header-container edit_block_header drag_handle">
		        <label class="lookup_block_name name">Primaries</label>
		    </div>

		    <div class="block_options">
		        <div class="control-selector">
		            <div class="control-selector__label-container">
		                <span class="selected-control-name"></span>
		                <i class="material-icons">expand_more</i>
		            </div>
		            <div class="control-selector__items-container">
		                <span data-control="wheels">Primaries Wheels</span>
		                <span data-control="sliders">Primaries Bars</span>
		            </div>
		        </div>

		        <div class="block-controls-container" data-control="wheels">
		            <div class="control-container colorwheel-style --lift">
		                <span class="control-title">Lift</span>
		                <div class="colorwheel-container" data-curve="lift-RGB" data-pass-index="1"></div>
		                <input type="range" min="-1" max="1" value="0" step="0.001" data-curve="lift-Y" data-pass-index="0" class="range_slider slider-control adjustmentBlock-slider">

						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="lift-Y" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-curve="lift-Y" data-pass-index="0" data-default-value="0"></input>
							<label for="lift-Y" class="slider-control-label">Y</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="lift-R" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="lift-R" data-pass-index="1" data-default-value="1.00"></input>
							<label for="lift-R" class="slider-control-label">R</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="lift-G" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="lift-G" data-pass-index="1" data-default-value="1.00"></input>
							<label for="lift-G" class="slider-control-label">G</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="lift-B" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="lift-B" data-pass-index="1" data-default-value="1.00"></input>
							<label for="lift-B" class="slider-control-label">B</label>
						</div>
		            </div>

		            <div class="control-container colorwheel-style --gamma">
		                <span class="control-title">Gamma</span>
		                <div class="colorwheel-container" data-curve="gamma-RGB" data-pass-index="3"></div>
		                <input type="range" min="-1" max="1" value="0" step="0.001" data-curve="gamma-Y" data-pass-index="2" class="range_slider slider-control adjustmentBlock-slider">

						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gamma-Y" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-curve="gamma-Y" data-pass-index="2" data-default-value="0"></input>
							<label for="gamma-Y" class="slider-control-label">Y</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gamma-R" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="gamma-R" data-pass-index="3" data-default-value="1.00"></input>
							<label for="gamma-R" class="slider-control-label">R</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gamma-G" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="gamma-G" data-pass-index="3" data-default-value="1.00"></input>
							<label for="gamma-G" class="slider-control-label">G</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gamma-B" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="gamma-B" data-pass-index="3" data-default-value="1.00"></input>
							<label for="gamma-B" class="slider-control-label">B</label>
						</div>
		            </div>

		            <div class="control-container colorwheel-style --gain">
		                <span class="control-title">Gain</span>
		                <div class="colorwheel-container" data-curve="gain-RGB" data-pass-index="5"></div>
		                <input type="range" min="-1" max="1" value="0" step="0.001" data-curve="gain-Y" data-pass-index="4" class="range_slider slider-control adjustmentBlock-slider">

						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gain-Y" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-curve="gain-Y" data-pass-index="4" data-default-value="0"></input>
							<label for="gain-Y" class="slider-control-label">Y</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gain-R" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="gain-R" data-pass-index="5" data-default-value="1.00"></input>
							<label for="gain-R" class="slider-control-label">R</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gain-G" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="gain-G" data-pass-index="5" data-default-value="1.00"></input>
							<label for="gain-G" class="slider-control-label">G</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gain-B" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="gain-B" data-pass-index="5" data-default-value="1.00"></input>
							<label for="gain-B" class="slider-control-label">B</label>
						</div>
		            </div>

		            <div class="control-container colorwheel-style --offset">
		                <span class="control-title">Offset</span>
		                <div class="colorwheel-container" data-curve="offset-RGB" data-pass-index="7"></div>
		                <input type="range" min="-1" max="1" value="0" step="0.001" data-curve="offset-Y" data-pass-index="6" class="range_slider slider-control adjustmentBlock-slider">

						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-Y" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-curve="offset-Y" data-pass-index="6" data-default-value="0"></input>
							<label for="offset-Y" class="slider-control-label">Y</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-R" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="offset-R" data-pass-index="7" data-default-value="1.00"></input>
							<label for="offset-R" class="slider-control-label">R</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-G" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="offset-G" data-pass-index="7" data-default-value="1.00"></input>
							<label for="offset-G" class="slider-control-label">G</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-B" value="1.00" min="0.00" max="1.00" step="0.001" class="slider-input-control" data-curve="offset-B" data-pass-index="7" data-default-value="1.00"></input>
							<label for="offset-B" class="slider-control-label">B</label>
						</div>
		            </div>
		        </div>

		        <div class="block-controls-container" data-control="sliders">
		            <div class="control-container sliders-style --lift">
		                <span class="control-title">Lift</span>
		                <div class="lines-container">
		                    <span class="line"></span>
		                    <span class="line"></span>
		                    <span class="line"></span>
		                </div>

		                <div class="slider-control --Y" data-curve="lift-Y" data-pass-index="8"></div>
		                <div class="slider-control --R" data-curve="lift-R" data-pass-index="9"></div>
		                <div class="slider-control --G" data-curve="lift-G" data-pass-index="9"></div>
		                <div class="slider-control --B" data-curve="lift-B" data-pass-index="9"></div>

						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="lift-Y" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="8" data-curve="lift-Y"></input>
							<label for="lift-Y" class="slider-control-label">Y</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="lift-R" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="9" data-curve="lift-R"></input>
							<label for="lift-R" class="slider-control-label">R</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="lift-G" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="9" data-curve="lift-G"></input>
							<label for="lift-G" class="slider-control-label">G</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="lift-B" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="9" data-curve="lift-B"></input>
							<label for="lift-B" class="slider-control-label">B</label>
						</div>

		            </div>

		            <div class="control-container sliders-style --gamma">
		                <span class="control-title">Gamma</span>
		                <div class="lines-container">
		                    <span class="line"></span>
		                    <span class="line"></span>
		                    <span class="line"></span>
		                </div>

		                <div class="slider-control --Y" data-curve="gamma-Y" data-pass-index="10"></div>
		                <div class="slider-control --R" data-curve="gamma-R" data-pass-index="11"></div>
		                <div class="slider-control --G" data-curve="gamma-G" data-pass-index="11"></div>
		                <div class="slider-control --B" data-curve="gamma-B" data-pass-index="11"></div>

						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gamma-Y" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="10" data-curve="gamma-Y"></input>
							<label for="gamma-Y" class="slider-control-label">Y</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gamma-R" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="11" data-curve="gamma-R"></input>
							<label for="gamma-R" class="slider-control-label">R</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gamma-G" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="11" data-curve="gamma-G"></input>
							<label for="gamma-G" class="slider-control-label">G</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gamma-B" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="11" data-curve="gamma-B"></input>
							<label for="gamma-B" class="slider-control-label">B</label>
						</div>
		            </div>

		            <div class="control-container sliders-style --gain">
		                <span class="control-title">Gain</span>
		                <div class="lines-container">
		                    <span class="line"></span>
		                    <span class="line"></span>
		                    <span class="line"></span>
		                </div>

		                <div class="slider-control --Y" data-curve="gain-Y" data-pass-index="12"></div>
		                <div class="slider-control --R" data-curve="gain-R" data-pass-index="13"></div>
		                <div class="slider-control --G" data-curve="gain-G" data-pass-index="13"></div>
		                <div class="slider-control --B" data-curve="gain-B" data-pass-index="13"></div>

						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gain-Y" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="12" data-curve="gain-Y"></input>
							<label for="gain-Y" class="slider-control-label">Y</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gain-R" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="13" data-curve="gain-R"></input>
							<label for="gain-R" class="slider-control-label">R</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gain-G" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="13" data-curve="gain-G"></input>
							<label for="gain-G" class="slider-control-label">G</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="gain-B" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="13" data-curve="gain-B"></input>
							<label for="gain-B" class="slider-control-label">B</label>
						</div>
		            </div>

		            <div class="control-container sliders-style --offset">
		                <span class="control-title">Offset</span>
		                <div class="lines-container">
		                    <span class="line"></span>
		                    <span class="line"></span>
		                    <span class="line"></span>
		                </div>

		                <div class="slider-control --Y" data-curve="offset-Y" data-pass-index="14"></div>
		                <div class="slider-control --R" data-curve="offset-R" data-pass-index="15"></div>
		                <div class="slider-control --G" data-curve="offset-G" data-pass-index="15"></div>
		                <div class="slider-control --B" data-curve="offset-B" data-pass-index="15"></div>

						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-Y" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="14" data-curve="offset-Y"></input>
							<label for="offset-Y" class="slider-control-label">Y</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-R" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="15" data-curve="offset-R"></input>
							<label for="offset-R" class="slider-control-label">R</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-G" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="15" data-curve="offset-G"></input>
							<label for="offset-G" class="slider-control-label">G</label>
						</div>
						<div class="input-group --with-knob">
							<input type="text" class="input-knob" />
							<input type="number" name="offset-B" value="0" min="-1" max="1" step="0.001" class="slider-input-control" data-pass-index="15" data-curve="offset-B"></input>
							<label for="offset-B" class="slider-control-label">B</label>
						</div>
		            </div>
		        </div>
		    </div>
		</li>
	</script>
</template>

<script>
export default {};
</script>

<style></style>
